export var RemoveTypeValues = ["this_only", "all"];
